import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Ssd = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M2 1.69h12a1.669 1.669 0 0 1 1.667 1.666v9.333A1.668 1.668 0 0 1 14 14.356H2a1.669 1.669 0 0 1-1.666-1.667V3.356a1.669 1.669 0 0 1 1.667-1.667Zm12 11.999a1 1 0 0 0 1-1V3.356a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v9.333a1 1 0 0 0 1 1h12Z" />
      <path d="M5.001 6.023h6a.333.333 0 0 1 .334.334V9.69a.333.333 0 0 1-.334.333h-6a.333.333 0 0 1-.333-.333V6.357a.333.333 0 0 1 .333-.334Zm5.667.667H5.335v2.667h5.333V6.69ZM2.5 4.355a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM13.5 4.355a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM2.5 12.69a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM13.5 12.69a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" />
    </svg>
  );
};

Ssd.category = 'product-category';

Ssd.displayName = 'Ssd';
